import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputBase from '@material-ui/core/InputBase';
import NativeSelect from '@material-ui/core/NativeSelect';
import drop from '../../assets/img/dropdown_arrow.png'

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    width: '12vw',
    height: '26px',
    boxShadow: '0px 0px 5px 0px #d6d6d6',
    backgroundColor: theme.palette.background.paper,
    padding: '2px 26px 1px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    [theme.breakpoints.down('md')]: {
      width: '7rem',
    },
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: 'green',
      boxShadow: '0 0 0 0.1rem rgba(0,12,255,.25)',
    },

  },
}))(InputBase);

function CustomSelect({ name, disabled, value, handleChange, options }) {
  return (
    <FormControl>
      <NativeSelect
        value={value}
        name={name}
        onChange={handleChange}
        disabled={disabled}
        input={<BootstrapInput />}
        IconComponent={(props) => (
          <img {...props} src={drop} style={{width: '12px', margin: '6px 10px 0 0'}} alt="drop_icon" />
        )}
      >
        {options.map(option => (
          <option key={option.value} value={option.value} disabled={option.value === ''}>{option.name}</option>
        ))}
      </NativeSelect>
  </FormControl>
  )
}

export default CustomSelect
